// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.item[data-v-4acabeb4] {\r\n  margin: 1.5rem 0;\n}\r\n", ""]);
// Exports
module.exports = exports;
